module.exports = __webpack_public_path__ + "static/form-analytics-a5a369f649415b0925d6c8052c08c796.png";